import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
// import LocationCityIcon from '@mui/icons-material/LocationCity';
import HomeCard from '../shared/HomeCard';
import { useAuth } from '../context/AuthContext';

export default function Home() {
  const { user } = useAuth();

  return (
    <div className="page">
      <div className="home-hero">
        <h1>Welcome{user?.name ? `, ${user.name}` : ''}</h1>
        <p>Choose a dashboard to get started.</p>
      </div>

      <section className="home-section">
        <div className="card-grid card-grid-landing">
          <HomeCard
            to="/main-dashboard"
            title="Dashboard"
            description="Survey data, analytics, uploads and validation-rule categories."
            icon={DashboardIcon}
            accent="var(--primary)"
          />
          {/*
          <HomeCard
          to="/sundargarh-hub"
          title="Sundargarh Dashboard"
          description="Live survey data, analytics and validation-rule categories, pulled directly from KoboToolbox."
          icon={LocationCityIcon}
          accent="var(--cat-subhadra)"
          />
          */}
          {user?.role === 'admin' && (
            <HomeCard
              to="/family-dashboard"
              title="Family Dashboard"
              description="Household segmentation framework, family priority index and family personas."
              icon={FamilyRestroomIcon}
              accent="var(--cat-women-child)"
            />
          )}
        </div>
      </section>
    </div>
  );
}
